<template>
    <div class="searchfieldholder">
        <input :class="{ active: isSearchfieldActive }" v-model="searchfieldValue"  type="text" name="searchfield" class="searchfield" placeholder="Zoek...">
        <img v-if="isSearchfieldActive" @click="resetSearchfieldValue" class="reset-btn" src="../../../assets/close-btn.png" alt="close button">
    </div>
</template>



<script>
import store from '../../../store'

export default {
    name: 'SearchfieldWithReset',
    props: {
        filterOn: String,
        filterBy: String
    },
    data () {
        return {
            searchfieldValuee: '',
        }
    },
    computed: {
        tekFilters () {
            return store.state.tekFilters
        },
        opdrFilters () {
            return store.state.opdrFilters
        },
        searchfieldValue: {
            get() { return this.filterOn },
            set(val) { 

                if (this.filterBy == "opdrachtnummer") {
                    this.opdrFilters.opdrachtnummer = val
                    store.commit('updateOpdrFilters', this.opdrFilters)
                }
                if (this.filterBy == "bedrijfsnaam") {
                    this.opdrFilters.bedrijfsnaam = val
                    store.commit('updateOpdrFilters', this.opdrFilters)
                }
                if (this.filterBy == "status") {
                    this.opdrFilters.status = val
                    store.commit('updateOpdrFilters', this.opdrFilters)
                }
            }
        },
        isSearchfieldActive () {
            if (this.searchfieldValue != "") {
                return true
            } else {
                return false
            }
        },
    },
    methods: {
        emitUpdate () {
            // $emit('tingtong', $event, 1, 2, 3, 4, "cupcakes")
            //this.filterOn = 
            //store.state.tekFilters.name = this.searchfieldValuee
        },
        resetSearchfieldValue() {
            this.searchfieldValue = ''
            //this.emitUpdate()
        }
    },

}
</script>

<style scoped>
    .searchfieldholder {
        position: relative;
        padding-right: 10px;

    }
    .reset-btn {
        position: absolute;
        width: 24px;
        height: 24px;
        top: 8px;
        right: 18px;
        cursor: pointer;
    }
    .searchfield {
        max-width: 200px;
        width: 100%;
        height: 40px;
        background-color: #E4ECFA;
        border-radius: 100px;
        border: none;
        font-size: 14px;
        padding: 10px 10px 10px 14px;
    }
    .active {
        background-color: #3076EA;
        color: white;
    }
</style>